import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=5f1159c2&scoped=true&"
import script from "./CardItem.vue?vue&type=script&lang=js&"
export * from "./CardItem.vue?vue&type=script&lang=js&"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=5f1159c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1159c2",
  null
  
)

export default component.exports